import React from "react";

const TopBar = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 3,
        backgroundImage:
          "radial-gradient(circle, #582b70, #442759, #332142, #231b2b, #141315)",
        color: "#fff",
      }}
    >
      <img src="/tzv-logo1.png" height={40} alt="tzv" style={{ padding: 5 }} />
    </div>
  );
};

export default TopBar;
